import { render, staticRenderFns } from "./PlaceSearch.vue?vue&type=template&id=12fef3b1&scoped=true&"
import script from "./PlaceSearch.vue?vue&type=script&lang=js&"
export * from "./PlaceSearch.vue?vue&type=script&lang=js&"
import style0 from "./PlaceSearch.vue?vue&type=style&index=0&id=12fef3b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fef3b1",
  null
  
)

export default component.exports